import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMotivoRevocacion } from '../shared/interfaces/firma_electronica';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class MotivoRevocacionService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/firma-electronica/motivos-revocacion`;
  }

  getMotivosRevocacion(): Observable<IMotivoRevocacion[]> {
    return this.http.get<IMotivoRevocacion[]>(`${this.baseUrl}`);
  }
}
